import React from 'react';
import FileUpload from '../components/file-upload/';
import PropTypes from 'prop-types';
import { getAttachmentsThumborURL, getThumborSize } from '../utils/getAttachmentsThumborUrl';

const defaultConfig = {
  acceptTypes: '.jpg,.jpeg,.pdf,.png',
  type: 'drag',
  errorInterval: 3000
};

const generateUploadProps = (defaultConfig, extraConfig) => {
  return Object.assign({}, defaultConfig, extraConfig);
};

const beforeUploadCallback = (files, file, maxCount, maxSize) => {
  if (reachMaxCount(files, maxCount)) {
    return {
      result: true,
      msg: `Maximum of ${maxCount} files can be uploaded at a time.`
    };
  }
  if (isFileSizeExceed(file, maxSize)) {
    return {
      result: true,
      msg: `Can’t upload your file. Maximum file size is ${maxSize}MB.`
    };
  }
  return {
    result: false
  };
};

const successCallback = (files = [], response, file, onChange) => {
  onChange(
    files.concat({
      uid: file.uid,
      databaseId: response.data && response.data.id ? response.data.id : ''
    })
  );
  const fileType = response.data.attributes.type;
  const imageURL = response.data.attributes.externalUrl;
  return {
    uid: file.uid,
    name: file.name,
    preview: getAttachmentsThumborURL(imageURL, getThumborSize(fileType), fileType)
  };
};

const removeCallback = (files, file, onChange) => {
  onChange(files.filter(fileItem => fileItem.uid !== file.uid));
  return {
    result: true
  };
};

const reachMaxCount = (files = [], maxCount) => files.length >= maxCount;

const isFileSizeExceed = (file, sizeLimit) => file.size / 1024 / 1024 > sizeLimit;

const UploadAttachment = props => {
  const {
    input: { onChange, value },
    maxCount,
    maxSize,
    ...rest
  } = props;
  const files = value || [];
  return (
    <div>
      <FileUpload
        {...generateUploadProps(defaultConfig, rest)}
        successCallback={(response, file) => successCallback(files, response, file, onChange)}
        removeCallback={file => removeCallback(files, file, onChange)}
        beforeUploadCallback={(files, file) => beforeUploadCallback(files, file, maxCount, maxSize)}
      />
    </div>
  );
};

UploadAttachment.propTypes = {
  onChange: PropTypes.func,
  uploadUrl: PropTypes.string,
  maxCount: PropTypes.number,
  maxSize: PropTypes.number,
  input: PropTypes.object
};

export default UploadAttachment;
